module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-144x144-64f6c48e196c1988d5fb9be67e87ee1f.png";